import { StaticRoom } from '../types';

export const getLargestRoomOccupancy = (rooms: Pick<StaticRoom, 'max_occupancy'>[]) => {
  const occupancies = rooms.map(({ max_occupancy }) => max_occupancy ?? 0);

  if (occupancies.length === 0 || occupancies.some((occupancy) => occupancy <= 0)) return null;

  return Math.max(...occupancies);
};
